import { Environment } from '@portal-core/environment/environment.model';
import { environment as coreEnvironment } from '@portal-core/environment/environment';

// Deployment-time overrides. Nothing in this workspace assigns mcEnvironment: inject-env.sh in
// MadCloud.Web.Tools/bash writes `<script>window.mcEnvironment={...}</script>` into the built
// index.html from the MC_* env vars (prefix stripped, camelCased), so its keys are Environment
// keys. Typed rather than `any` so the spread below is checked against the interface.
declare const window: { mcEnvironment?: Partial<Environment> };

export const environment: Environment = {
  ...coreEnvironment,
  ...window.mcEnvironment
};
